import { useRef } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { StockTransferForm } from "@/components/stock-transfers/stock-transfer-form";
import { Id } from "@/convex/_generated/dataModel";

export const Route = createFileRoute("/_authenticated/stock-transfers/new")({
  validateSearch: (search: Record<string, unknown>) => ({
    draft: typeof search.draft === "string" ? search.draft : undefined,
  }),
  component: NewStockTransferPage,
});

function NewStockTransferPage() {
  const { draft } = Route.useSearch();
  const navigate = useNavigate();
  const coldDraftRef = useRef(draft);

  return (
    <RouteGuardPermissions
      permissions={[{ module: "stock_transfers", actions: ["create"] }]}
    >
      <StockTransferForm
        transferId={
          coldDraftRef.current
            ? (coldDraftRef.current as Id<"stock_transfers">)
            : undefined
        }
        onDraftCreated={(id) =>
          navigate({
            to: "/stock-transfers/new",
            search: { draft: id },
            replace: true,
          })
        }
      />
    </RouteGuardPermissions>
  );
}
